export const datePickerOnChange = (newValue,setStartDateOpen,setDate,setstartDateFormat,setSelectedStartDate,setEndDateOpen) => {
    setSelectedStartDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(newValue.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

 export const datePickerOnChangeEnd = (newValue,setEndDateOpen,setSelectedEndDate,setDisplayEndDate,setEndDate) => {
    setSelectedEndDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(newValue.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };